// React
import React, { Fragment, useCallback } from 'react'
import PropTypes from 'prop-types'

// Components
import { Button as ButtonContainer, HostStyles, Label } from './styles'

// Shared
import { withTranslation } from 'shared/utils/withTranslation'
import { useNavigation } from 'shop-components/utils/navigation'

const BackToStoreButton = ({ disabled, t }) => {
  const { backToStore } = useNavigation()

  const handleGoBackToStore = useCallback((e) => {
    e?.preventDefault()

    backToStore()
  }, [])

  return (
    <Fragment>
      <HostStyles />
      <ButtonContainer
        onClick={disabled ? undefined : handleGoBackToStore}
        disabled={disabled}
        className="bq-button"
        secondary
      >
        <Label>{t('user.store.continue_shopping')}</Label>
      </ButtonContainer>
    </Fragment>
  )
}

BackToStoreButton.displayName = 'Button'

BackToStoreButton.propTypes = {
  disabled: PropTypes.bool,
  t: PropTypes.func
}

export default withTranslation('user')(BackToStoreButton)
